export default __webpack_public_path__ + "static/media/574.95c23fd8.png";